import React from "react";

export default ({ color = "black", opacity = "0.8", borderColor = "fff", className = "", onClick = () => {} }) => (
  <svg
    width="30"
    height="30"
    className={className ? className : ""}
    onClick={onClick}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <g id="addfvideo">
      <circle id="Ellipse 4" cx="15" cy="15" r="13" fill="#FDFDFD" />
      <path
        id="Path"
        d="M13.5026 10.8737C12.836 10.4861 12 10.967 12 11.7382V18.7275C12 19.4987 12.836 19.9796 13.5026 19.592L19.5132 16.0973C20.1763 15.7118 20.1763 14.7539 19.5132 14.3684L13.5026 10.8737Z"
        fill={color}
        fillOpacity={opacity}
      />
    </g>
  </svg>
);
